export const LEFT_ARROW_ICON = `<svg class="filters-tooltip-arrow filters-tooltip-arrow-left"
	viewBox="0 0 5 7"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
<path
		d="M3.70703 0.5L0.707031 3.5L3.70703 6.5"
		stroke="black"
		stroke-linecap="round"
	/>
</svg>
`;

export const RIGHT_ARROW_ICON = `<svg class="filters-tooltip-arrow filters-tooltip-arrow-right" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="black" stroke-linecap="round"/>
</svg>`;

export const AIR_STRIKE_LABELS = {
	0: 'nem',
	1: 'igen'
};

export const SLIDER_SETTINGS = {
	connect: true,
	snap: true
};
